"use client";

import { motion, AnimatePresence } from "framer-motion";

interface AnimatedSwitchProps {
  children: React.ReactNode;
  active: boolean;
  className?: string;
  duration?: number;
  ease?: string;
}

const AnimatedSwitch = ({ children, active, className, duration = 0.4, ease = "circInOut" }: AnimatedSwitchProps) => {
  return (
    <AnimatePresence mode="wait">
      {active && (
        <motion.div
          className={className}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration, ease }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AnimatedSwitch;
